<template>
  <div class="pump-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F_pump = B · I · L | 无机械磨损泵$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Pipe -->
          <rect x="50" y="100" width="300" height="40" fill="rgba(85,85,85,0.2)" stroke="#888" />
          
          <!-- Liquid Metal (Mercury/Sodium) -->
          <rect x="50" y="105" width="300" height="30" fill="rgba(200, 200, 200, 0.4)" stroke="none" />
          
          <!-- Magnetic Field (Poles) -->
          <rect x="150" y="60" width="100" height="20" fill="#ff4757" rx="2" />
          <text x="190" y="75" fill="#fff" font-size="10">N</text>
          <rect x="150" y="160" width="100" height="20" fill="#00d2ff" rx="2" />
          <text x="190" y="175" fill="#fff" font-size="10">S</text>

          <!-- Electrodes (Injecting current I across the pipe) -->
          <rect x="170" y="100" width="5" height="40" fill="#ffd700" />
          <rect x="225" y="100" width="5" height="40" fill="#ffd700" />
          <text x="160" y="95" fill="#ffd700" font-size="8">电流 I</text>

          <!-- Fluid flow particles -->
          <circle v-for="n in 15" :key="n" :cx="calcPartX(n)" :cy="110 + (n*5)%25" r="2" fill="#fff" opacity="0.6" />

          <!-- Force vector -->
          <path v-if="current > 0" d="M 240,120 L 300,120" stroke="#ff4757" stroke-width="2" marker-end="url(#arrow)" />
          <text v-if="current > 0" x="250" y="115" fill="#ff4757" font-size="8">推力 F</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>泵压动力: {{ (current * 0.4).toFixed(1) }} Pa</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节泵出电流 I</label>
             <el-slider v-model="current" :min="0" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>电磁泵是一种没有机械运动部件的泵。它利用**安培力**（洛伦兹力的宏观表现）直接驱动导电液体。在垂直于管道方向施加磁场，并同时在液体中通入电流，根据左手定则，液体会受到沿管道方向的推力。它极大提高了输送高温、高腐蚀性或放射性液态金属（如核反应堆的钠冷却剂）的安全性。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElectromagneticPumpViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      current: 40,
      time: 0,
      timer: null
    }
  },
  methods: {
    calcPartX(n) {
       return 50 + ((this.time * this.current * 0.1 + n * 30) % 300);
    },
    update() {
       this.time += 0.5;
       this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.pump-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
